export default __webpack_public_path__ + "static/media/onspring.760637fe.svg";